import { useMutation, useQueryClient } from "react-query";

import { crearParametro, updateParametro, deleteParametro } from '../../services/parametros';

import { toast } from 'react-hot-toast';
const queryKey = "parametros";

export const useParametrosMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addParam = useMutation((body) => crearParametro(body), {
    onSuccess,
    onError: (err) => onError(err),
  });

  const updateParam = useMutation(
    (body) => updateParametro( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeParam = useMutation((id) => deleteParametro( id), {
    onSuccess,
    onError,
  });

  return { addParam, updateParam, removeParam };
};
export default useParametrosMutations;